<template>
	<span class="emoji">{{ attrs?.emoji ?? "" }}</span>

	<!-- Could do something like this if we wanted to use fallback images:
	<img class="not-prose size-5" :src="attrs?.fallbackImage || '#'" />
	-->
</template>

<script setup lang="ts">
/*
 * Replacement for storyblok's default emoji renderer, which renders all emojis as fallback images rather than just sticking to the actual emoji character! The default is pretty crazy because emojis are supported on virtually all devices. Some new ones as well as flag emojis might not work on all devices, but it's better to just avoid those on the CMS side.
 */
import type {SbVueRichTextProps} from "@storyblok/vue";

// eslint-disable-next-line vue/prop-name-casing -- Lint issues come from the library
defineProps<SbVueRichTextProps["emoji"]>();
</script>
